export enum Roles {
    ADMIN = 'ADMIN',
    JOB_SEEKER = 'JOB_SEEKER',
    ADVERTISER = 'ADVERTISER',
    MARKETER = 'MARKETER',
}